
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.7928 8L7.94888 11.714C7.64074 12.0081 7.64074 12.4854 7.94888 12.7795C8.25702 13.0735 8.75718 13.0735 9.06532 12.7795L13.4995 8.50218C13.7905 8.22445 13.7905 7.77484 13.4995 7.49782L9.06532 3.22055C8.75718 2.92649 8.25702 2.92649 7.94888 3.22055C7.64074 3.51461 7.64074 3.99192 7.94888 4.28598L11.7928 8Z","fill":"#10001F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.34362 8L2.49966 11.714C2.19152 12.0081 2.19152 12.4854 2.49966 12.7795C2.8078 13.0735 3.30797 13.0735 3.6161 12.7795L8.05029 8.50218C8.34131 8.22445 8.34131 7.77484 8.05029 7.49782L3.6161 3.22055C3.30797 2.92649 2.8078 2.92649 2.49966 3.22055C2.19152 3.51461 2.19152 3.99192 2.49966 4.28598L6.34362 8Z","fill":"#10001F"}})])
          )
        }
      }
    